import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialTwitter = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m10.819 13.405 5.23 7.32a.66.66 0 0 0 .535.275h2.761a.657.657 0 0 0 .653-.701.65.65 0 0 0-.12-.333l-6.696-9.371-5.232-7.32A.66.66 0 0 0 7.416 3H4.655a.657.657 0 0 0-.653.701c.008.12.05.235.12.333zm2.362-2.81L19.568 3M10.82 13.405 4.433 21"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialTwitter) as SvgIcon;
export { ForwardRef as ReactComponent };
